import { Button, Img, Text } from "components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { globalRequest } from "../../../../utils/global/globalRequest";
import { USERS } from "../../../../utils/helper/Enum";
import { refreshToken } from "../../../../utils/helper/custom";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import { getAuth, updatePreferredLn } from "../../../../redux/reducers/loginData";

const Preferredlanguage = () => {
  let auth = useSelector(getAuth);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [preferredLang, setPreferredLang] = useState(auth?.preferredLang);

  /**
   * change Language
   */
  const changeLanguage = async (language) => {
    dispatch(changeLoader(true));
    let input_data = { lang: language };
    try {
      let response = await globalRequest(
        USERS?.SET_PREFFERED_LANG,
        "put",
        input_data,
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        dispatch(updatePreferredLn(language));
        setPreferredLang(language);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        refreshToken();
        return;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  return (
    <>
      <div className="flex flex-col w-full mb-7">
        {/* ── Page title ── */}
        <Text
          className="text-[20px] font-medium leading-[28px] font-['Inter'] text-[var(--Blacks-900,#1A1A1A)] mb-6"
        >
          {t("preferredLanguage")}
        </Text>

        {/*
          ── COMMENTED: old subtitle text ──
          <Text className="mb-10" size="txtnunitoRegular16Gray700">
            {t("chooseInWhichLanguagePlatformShouldSendYouEmailAndPushNotifications")}
          </Text>
        */}

        {/* ── Language option cards ── */}
        <div className="flex flex-row items-center justify-start gap-4 w-full mb-6 xs:flex-col">
          <ToggleButton
            buttonId="button1"
            active={preferredLang == "en"}
            onClick={() => setPreferredLang("en")}
            flagIcons="images/english.svg"
            text="English"
          />
          <ToggleButton
            buttonId="button2"
            active={preferredLang == "ar"}
            onClick={() => setPreferredLang("ar")}
            flagIcons="images/amount.png"
            text="عربي"
          />
        </div>

        {/* ── Full-width Update button ── */}
        <button
          className="w-full py-[14px] rounded-full text-[16px] font-medium leading-[24px] text-center font-['Unbounded'] text-[white] tracking-wide cursor-pointer transition-opacity hover:opacity-90"
          style={{ backgroundColor: "#7B1A3C" }}
          onClick={() => changeLanguage(preferredLang)}
        >
          {t("update")}
        </button>

        {/*
          ── COMMENTED: old fixed-width Button component ──
          <Button
            className="w-[140px]"
            size="lg"
            variant={"FillBlack"}
            hover={true}
            hoverclass="bg-white-A700"
            onClick={(e) => { changeLanguage(preferredLang); }}
          >
            {t("update")}
          </Button>
        */}
      </div>
    </>
  );
};

const ToggleButton = ({ buttonId, active, onClick, text, flagIcons }) => {
  const handleClick = () => {
    onClick(buttonId);
  };

  /*
    ── COMMENTED: old activeHighlight className strings ──
    const activeHighlight = active
      ? "text-[16px] font-nunitomedium flex flex-row items-center justify-start gap-4 w-full max-w-[250px] bg-white-A700 text-black-900 text-sm border border-solid border-pink-800"
      : "text-[16px] font-nunitomedium flex flex-row items-center justify-start gap-4 w-full max-w-[250px] bg-white-A700 text-black-900 text-sm border border-solid border-gray-300";
  */

  return (
    <div
      className={`
        flex flex-row items-center justify-between
        flex-1 xs:w-full
        px-4 py-3 rounded-xl border cursor-pointer
        bg-[white] transition-colors
        ${active ? "border-gray-300" : "border-gray-200"}
      `}
      onClick={handleClick}
    >
      {/* Left: flag + language name */}
      <div className="flex flex-row items-center gap-3">
        <Img
          src={flagIcons}
          alt="flag-icon"
          className="h-8 w-8 rounded-full object-cover flex-shrink-0"
        />
        <Text
          className="text-[15px] font-medium text-black-900 font-['Inter']"
        >
          {text}
        </Text>
      </div>

      {/* Right: radio indicator */}
      <div
        className={`
          flex items-center justify-center
          w-5 h-5 rounded-full border-2 flex-shrink-0
          ${active ? "border-[#7B1A3C]" : "border-gray-300"}
        `}
      >
        {active && (
          <div className="w-2.5 h-2.5 rounded-full bg-[#7B1A3C]" />
        )}
      </div>
    </div>
  );
};

export default Preferredlanguage;